(function () {
    'use strict';

    angular.module("imApp").factory("productEanService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductEan: function (parms) {
                return $ihttp.post({
                    method: 710,
                    parameters: parms || {}
                });
            },
            getNextEan: function (parms) {
                return $ihttp.post({
                    method: 1690,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 711,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 712,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
